import { Box, Typography } from "@material-ui/core";
import moment from "moment";
import React from "react";

export const OfferTableHeaderData = ({ isDarkMode }) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 190,
    headerName: "Offer Name",
    field: "vendorOfferName",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "vendorOfferName",
    isDefaultFilterColumn: true,
    fieldKey: "vendorOfferName",
    formFieldTitle: "Vendor Offer Name",
    disableColumnMenu: true,
    searchKey: "Vendor Offer Name",
    renderCell: (item) => {
      return (
        <Typography
          style={{
            fontWeight: 500,
            fontSize: "14px",
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.vendorOfferName}
        </Typography>
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 190,
    headerName: "Vendors",
    field: "vendorName",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "vendorName",
    isDefaultFilterColumn: true,
    fieldKey: "vendorName",
    formFieldTitle: "Vendor Name",
    disableColumnMenu: true,
    searchKey: "Vendor Name",
    renderCell: (item) => {
      return (
        <Typography
          style={{
            fontWeight: 500,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.vendorName}
        </Typography>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 190,
    headerName: "Company",
    field: "companyName",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "companyName",
    isDefaultFilterColumn: true,
    fieldKey: "companyName",
    formFieldTitle: "Company Name",
    disableColumnMenu: true,
    searchKey: "companyName",
    renderCell: (item) => {
      return (
        <Box display="flex" gridGap={"8px"} alignItems="center">
          <img src={"/images/logoCapsule.png"} alt={item?.row?.companyName} />
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              color: !isDarkMode ? "#101828" : "#F5F5F6",
            }}
          >
            {item?.row?.companyName}
          </Typography>
        </Box>
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 190,
    headerName: "Date of interest",
    field: "createdOn",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "createdOn",
    isDefaultFilterColumn: false,
    fieldKey: "createdOn",
    formFieldTitle: "Date of Interest",
    disableColumnMenu: true,
    searchKey: "createdOn",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 500,
            fontSize: "14px",
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {moment(item?.row?.createdOn).format("DD MMM YYYY")}
        </label>
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 190,
    headerName: "Discount",
    field: "discountPercentage",
    sortable: false,
    filterable: false,
    fieldType: "text",
    displayPath: "discountPercentage",
    isDefaultFilterColumn: true,
    fieldKey: "discountPercentage",
    formFieldTitle: "Discount Percentage",
    disableColumnMenu: true,
    searchKey: "Discount Percentage",
    renderCell: (item) => {
      return (
        <Typography
          style={{
            fontWeight: 500,
            fontSize: "14px",
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.discountPercentage}%
        </Typography>
      );
    },
  },
];
